import { supabase } from '@/lib/supabase';

/**
 * Gets a proxied image URL if needed
 * @param url The image URL to potentially proxy
 * @param isForUpload Optional flag indicating if the URL is for an upload operation
 * @returns The proxied or original URL
 */
export const getProxiedImageUrl = async (url: string, isForUpload: boolean = false): Promise<string> => {
  // If for upload, no URL provided, or it's already from our database or already proxied, return it as is
  if (isForUpload || 
      !url || 
      url.includes('db.dexfinds.com') || 
      url.includes('api.dexfinds.com/image/') ||
      url.includes('pemjkmuyskhnljayweiu.supabase.co')) {
    return url;
  }

  try {
    // Construct the proxied URL
    const proxiedUrl = `https://api.dexfinds.com/image/?url=${encodeURIComponent(url)}`;
    return proxiedUrl;
  } catch (error) {
    console.error('Error proxying image:', error);
    return url; // Fallback to original URL
  }
};
